import ProjectSettingsToolchainQuery, {
	type ToolchainLayoutQuery,
} from '@jira/project-settings__toolchain/src/__generated__/ToolchainLayoutQuery.graphql';
import type { PreloadedQuery } from 'react-relay';
import { createRelayResource } from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import type { RouteResource } from '@atlassian/react-resource-router';

export const RESOURCE_TYPE_TOOLCHAIN_RELAY = 'PROJECT_SETTINGS_TOOLCHAIN';

export const projectSettingsToolchainResource: RouteResource<
	PreloadedQuery<ToolchainLayoutQuery, Record<string, unknown>>
> = createRelayResource<ToolchainLayoutQuery>({
	type: RESOURCE_TYPE_TOOLCHAIN_RELAY,
	getQuery: (_, { tenantContext }) => ({
		parameters: ProjectSettingsToolchainQuery,
		variables: {
			cloudId: tenantContext?.cloudId || '',
		},
		options: { fetchPolicy: 'store-and-network' },
	}),
});
